// Alternate name types for eFiling parties
export const ALTERNATE_NAME_TYPES = [
    { code: 'AKA', name: 'AKA (Also Known As)' },
    { code: 'Alias', name: 'Alias' },
    { code: 'DBA', name: 'DBA (Doing Business As)' },
    { code: 'ESA', name: 'ESA (Erroneously Sued As)' },
    { code: 'FDBA', name: 'FDBA (Formerly Doing Business As)' },
    { code: 'FKA', name: 'FKA (Formerly Known As)' },
];
